// src/components/page/ar-space/ArSpaceCard.tsx
'use client';

import Avatar from '@/components/ui/avatar/Avatar';
import { IconLocation, IconPhoto, IconUserGroup } from '@/components/icons';
import type { ArSpace } from '@/types/arSpace';
import style from './ArSpaceCard.module.scss';
import Link from 'next/link';
import LazyImage from '@/components/ui/lazyImage/LazyImage';
import { MoreBtn } from './MoreBtn';

type Props = {
  item: ArSpace;
  onOpenScan: (item: ArSpace) => void;
  onOpenMap: (item: ArSpace) => void;
  highlight?: (text: string) => React.ReactNode; // 可選：關鍵字高亮
  onDeleted?: (arSpaceId: string | number) => void;
};

const ArSpaceCard = ({ item, onOpenMap, highlight, onDeleted }: Props) => {
  const cover = item.cover?.trim() || undefined;
  const title = highlight ? highlight(item.title) : item.title;
  const hasAddress = !!item.address?.trim();
  // const footerText = item.branch_name || item.address || item.title;

  // 依 ar_type 決定頭像/名稱點擊導向
  const ownerHref =
    item.ar_type === 'branch' ? `/store/${item.owner_open_id}` : `/user/${item.owner_open_id}`;

  //對應的AR內頁網址
  const href =
    item.ar_type === 'branch'
      ? `/ar-space/${item.branch_id ?? item.id}?type=branch`
      : `/ar-space/${item.id}?type=ar_space`;
  // ? `/store/${item.owner_open_id}/ar-space/${item.id}`
  // : `/user/${item.owner_open_id}/ar-space/${item.id}`;

  return (
    <div className="col">
      <div className={`card h-100 ${style.item}`}>
        <span className={`badge rounded-pill bg-danger ${style.badgeL}`}>AR</span>

        <span
          className={`badge rounded-pill bg-light text-dark d-flex align-items-center ${style.badgeR} right-0`}
        >
          <span className="me-1">
            <IconUserGroup />
          </span>
          {item.article_num}人打卡
        </span>
        <Link href={href} scroll={false} className="p-0 border-0 w-100">
          {cover ? (
            <div
              className="card-img-top position-relative"
              style={{
                aspectRatio: '1 / 1', // 保持方形
              }}
            >
              <LazyImage
                src={cover}
                alt={item.title || 'AR 空間封面'}
                className="card-img-top position-relative"
                aspect="1/1"
                imgStyle={{ objectFit: 'cover' }}
                radius={0}
                sizes="(min-width: 1200px) 20vw, (min-width: 768px) 25vw, 50vw"
              />
            </div>
          ) : (
            // 沒有圖片狀態
            <div
              className="card-img-top d-flex align-items-center justify-content-center bg-grey-100"
              style={{ aspectRatio: '1/1' }}
              aria-label="無封面圖片"
            >
              <span className="text-grey-700 small">
                <IconPhoto width={30} />
              </span>
            </div>
          )}
        </Link>

        <div className="card-body p-3">
          <div className="position-relative d-flex align-items-center mb-2">
            <Link href={ownerHref}>
              <Avatar src={item.owner_photo} size={30} border={1} borderColor="grey" />
            </Link>
            <span className="ms-2 text-grey-700 flex-fill fs-sm-1">
              <Link href={ownerHref} className="text-decoration-none text-reset">
                {item.owner_name}
              </Link>
            </span>
            <div className={`${style.btnMore}`}>
              <MoreBtn arSpace={item} onDeleted={onDeleted} showFavor={false} showReport={false} />
            </div>
          </div>

          <h5 className={`card-title mb-0 fs-6 ${style.title}`}>
            <Link href={href} scroll={false}>
              {title}
            </Link>
          </h5>
          {hasAddress ? (
            <button
              type="button"
              className={`d-flex align-items-center btn text-grey-800 fs-sm-2 p-0 mt-2 ${style.local}`}
              onClick={() => onOpenMap(item)}
              aria-label={`開啟 ${item.title} 的地圖`}
              title="查看地圖"
            >
              <span>
                <IconLocation width={16} />
                {item.ar_type === 'branch' ? item.address : item.branch_name}
              </span>
            </button>
          ) : (
            <div className="d-flex align-items-center text-grey-800 fs-sm-2 p-0 mt-2">
              <IconLocation width={16} />
              {item.ar_type === 'branch' ? item.address : item.branch_name}
            </div>
          )}
          {/* <div className="d-grid g-2 mt-2">
            <button type="button" className="btn btn-red" onClick={() => onOpenScan(item)}>
              掃圖抓AR籌碼
            </button>
          </div> */}
        </div>

        {/*hasAddress ? (
          <div className={`card-footer ${style.footer}`}>
            <small className="text-muted">
              <button
                type="button"
                className="d-flex align-items-center btn text-grey-800 fs-sm-2 p-0 align-baseline text-decoration-none"
                onClick={() => onOpenMap(item)}
                aria-label={`開啟 ${item.title} 的地圖`}
                title="查看地圖"
              >
                <IconLocation width={15} className="me-1" />
                {footerText}
              </button>
            </small>
          </div>
        ) : (
          <div className={`card-footer ${style.footer}`}>
            <small className="d-flex align-items-center text-muted text-grey-800 fs-sm-2">
              {item.branch_name}
            </small>
          </div>
        )*/}
      </div>
    </div>
  );
};

export default ArSpaceCard;
